import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getCompanyAnalytics, getLoadingStatus } from '../../../../redux/company/selectors';
import { companyActions } from '../../../../redux/company/actions';

export const useCompanyAnalyticsData = () => {
  const { companyId } = useParams();
  const dispatch = useDispatch();
  const companyAnalyticsData = useSelector(getCompanyAnalytics);
  const loading = useSelector(getLoadingStatus);

  useEffect(() => {
    if (!companyId) return;

    dispatch(companyActions.loadCompanyAnalytics(companyId));
  }, [dispatch, companyId]);

  return { companyAnalyticsData, loading };
};
